// Coherent logo family for the OmniSearch suite.
// Each logo = rounded-square container with a unique colored gradient + a distinctive glyph.

const BRANDS = {
  search: {
    gradFrom: "#FF7038", gradTo: "#B03200",
    label: "OmniSearch", accent: "#FF4500",
    glyph: (
      <>
        <circle cx="32" cy="29" r="11" fill="none" stroke="#fff" strokeWidth="4" />
        <line x1="40" y1="38" x2="48" y2="46" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
      </>
    ),
  },
  mail: {
    gradFrom: "#FB7185", gradTo: "#9F1239",
    label: "OmniMail", accent: "#E11D48",
    glyph: (
      <>
        <rect x="14" y="20" width="36" height="24" rx="4" fill="none" stroke="#fff" strokeWidth="3.5" />
        <path d="M14 22 L32 36 L50 22" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinejoin="round" />
      </>
    ),
  },
  tube: {
    gradFrom: "#F87171", gradTo: "#991B1B",
    label: "OmniTube", accent: "#DC2626",
    glyph: (
      <>
        <rect x="12" y="18" width="40" height="28" rx="7" fill="#fff" />
        <path d="M28 26 L40 32 L28 38 Z" fill="#991B1B" />
      </>
    ),
  },
  ai: {
    gradFrom: "#A78BFA", gradTo: "#5B21B6",
    label: "OmniAI", accent: "#7C3AED",
    glyph: (
      <>
        <path d="M32 14 L34.5 27 L46 32 L34.5 37 L32 50 L29.5 37 L18 32 L29.5 27 Z" fill="#fff" />
        <circle cx="46" cy="20" r="3" fill="#fff" opacity="0.8" />
      </>
    ),
  },
  drive: {
    gradFrom: "#FCD34D", gradTo: "#B45309",
    label: "OmniDrive", accent: "#F59E0B",
    glyph: (
      <>
        <path d="M24 16 L40 16 L52 38 L36 38 Z" fill="#fff" opacity="0.95" />
        <path d="M16 38 L24 16 L36 38 L28 50 Z" fill="#fff" opacity="0.75" />
        <path d="M28 50 L52 50 L52 38 L36 38 Z" fill="#fff" opacity="0.55" />
      </>
    ),
  },
  map: {
    gradFrom: "#6EE7B7", gradTo: "#065F46",
    label: "OmniMap", accent: "#10B981",
    glyph: (
      <>
        <path d="M32 14 C24 14 18 20 18 28 C18 36 32 50 32 50 C32 50 46 36 46 28 C46 20 40 14 32 14 Z" fill="#fff" />
        <circle cx="32" cy="27" r="5" fill="#065F46" />
      </>
    ),
  },
};

export function OmniLogo({ brand = "search", size = 48, rounded = 0.28, className = "" }) {
  const b = BRANDS[brand] || BRANDS.search;
  const id = `omnigrad-${brand}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-label={b.label}
    >
      <defs>
        <radialGradient id={id} cx="30%" cy="30%" r="80%">
          <stop offset="0%" stopColor={b.gradFrom} />
          <stop offset="65%" stopColor={b.accent} />
          <stop offset="100%" stopColor={b.gradTo} />
        </radialGradient>
      </defs>
      <rect width="64" height="64" rx={Math.round(64 * rounded)} fill={`url(#${id})`} />
      {b.glyph}
    </svg>
  );
}

export const BRAND_COLORS = Object.fromEntries(
  Object.entries(BRANDS).map(([k, v]) => [k, v.accent])
);
